


  
  

  var faLightArrowLeftToArcCircleMinus = {
    prefix: 'fak',
    iconName: 'light-arrow-left-to-arc-circle-minus',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M0 256C0 114.6 114.6 0 256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256zm160 0c0-4.6 2-9 5.4-12l144-128-.1 .1c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L218.1 240l157.1 0c-10.1 9.6-19.1 20.3-26.7 32l-130.4 0 102 90.7c-.1 1.8-.1 3.6-.1 5.3c0 10.9 1 21.5 2.9 31.8c-4.7 .8-9.7-.4-13.5-3.8l-144-128c-3.4-3.1-5.4-7.4-5.4-12zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightArrowRightToArcCircleBolt = {
    prefix: 'fak',
    iconName: 'light-arrow-right-to-arc-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M0 256c0-8.8 7.2-16 16-16l277.9 0L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3l-.1-.1 144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272 16 272c-8.8 0-16-7.2-16-16zM240 16c0-8.8 7.2-16 16-16C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.2 100.3 358.1 32 256 32c-8.8 0-16-7.2-16-16zm0 480c0-8.8 7.2-16 16-16c32.2 0 62.9-6.8 90.6-19.1c5.8 9.3 12.5 18.1 19.9 26.1C333 503 295.5 512 256 512c-8.8 0-16-7.2-16-16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm44.6 3.8c-1.6-4.9 .1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6s5.4 9.9 2.6 14.9L516.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380 440 380c-5.2 0-9.8-3.3-11.4-8.2z'
      
    ]
  };

  

  
  

  var faLightArrowRightToArcCircleCheck = {
    prefix: 'fak',
    iconName: 'light-arrow-right-to-arc-circle-check',
    icon: [
      640,
      512,
      [],
      'e013',
      
      'M0 256c0-8.8 7.2-16 16-16l277.9 0L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3l-.1-.1 144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272 16 272c-8.8 0-16-7.2-16-16zM240 16c0-8.8 7.2-16 16-16C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.2 100.3 358.1 32 256 32c-8.8 0-16-7.2-16-16zm0 480c0-8.8 7.2-16 16-16c32.2 0 62.9-6.8 90.6-19.1c5.8 9.3 12.5 18.1 19.9 26.1C333 503 295.5 512 256 512c-8.8 0-16-7.2-16-16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm44.7-11.3c6.2-6.2 16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightArrowRightToArcCircleMinus = {
    prefix: 'fak',
    iconName: 'light-arrow-right-to-arc-circle-minus',
    icon: [
      640,
      512,
      [],
      'e00f',
      
      'M0 256c0-8.8 7.2-16 16-16l277.9 0L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3l-.1-.1 144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272 16 272c-8.8 0-16-7.2-16-16zM240 16c0-8.8 7.2-16 16-16C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.2 100.3 358.1 32 256 32c-8.8 0-16-7.2-16-16zm0 480c0-8.8 7.2-16 16-16c32.2 0 62.9-6.8 90.6-19.1c5.8 9.3 12.5 18.1 19.9 26.1C333 503 295.5 512 256 512c-8.8 0-16-7.2-16-16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightBarsCircleArrowLeft = {
    prefix: 'fak',
    iconName: 'light-bars-circle-arrow-left',
    icon: [
      640,
      512,
      [],
      'e004',
      
      'M0 80c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 64C7.2 64 0 71.2 0 80zM0 240c0 8.8 7.2 16 16 16l344.2 0c10-12.1 21.7-22.9 34.6-32L16 224c-8.8 0-16 7.2-16 16zM0 400c0 8.8 7.2 16 16 16l310.6 0c-2.9-10.3-4.9-21-5.9-32L16 384c-8.8 0-16 7.2-16 16zm352-31.9c0 51.4 27.4 99 72 124.7s99.4 25.7 144 0s72-73.3 72-124.7s-27.4-99-72-124.7s-99.4-25.7-144 0s-72 73.3-72 124.7zm32 0c0-40 21.3-77 56-97s77.3-20 112 0s56 57 56 97s-21.3 77-56 97s-77.3 20-112 0s-56-57-56-97zm36.7-11.4c-6.3 6.3-6.3 16.4 0 22.7l56 56c6.2 6.1 16.4 6.1 22.6-.1s6.2-16.4 0-22.6L470.6 384l89.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-89.4 0 28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56 56z'
      
    ]
  };

  

  
  

  var faLightCircleCheckCircleArrowRight = {
    prefix: 'fak',
    iconName: 'light-circle-check-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e008',
      
      'M34.3 128C80 48.8 164.5 0 256 0s176 48.8 221.7 128c11.8 20.4 20.5 42 26.2 64.2c-2.6-.1-5.3-.2-7.9-.2c-8.4 0-16.7 .6-24.8 1.7c-5-17.2-12-33.9-21.2-49.7C410 74.7 336 32 256 32S102 74.7 62 144s-40 154.7 0 224s114 112 194 112c31.7 0 62.5-6.7 90.5-19.1c5.8 9.3 12.5 18 19.8 26.1c-33.9 16.2-71.5 25-110.4 25c-91.5 0-176-48.8-221.7-128s-45.7-176.8 0-256zM148.7 244.7c6.2-6.2 16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-42.7 42.7-85.3 85.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightCircleRotate = {
    prefix: 'fak',
    iconName: 'light-circle-rotate',
    icon: [
      640,
      512,
      [],
      'e00c',
      
      'M34.3 128C80 48.8 164.5 0 256 0s176 48.8 221.7 128c11.8 20.4 20.5 42 26.2 64.2c-2.6-.1-5.3-.2-7.9-.2c-8.4 0-16.7 .6-24.8 1.7c-5-17.2-12-33.9-21.2-49.7C410 74.7 336 32 256 32S102 74.7 62 144s-40 154.7 0 224s114 112 194 112c31.7 0 62.5-6.7 90.5-19.1c5.8 9.3 12.4 18.1 19.8 26.1c-33.9 16.2-71.5 25-110.4 25c-91.5 0-176-48.8-221.7-128s-45.7-176.8 0-256zM352 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 37.5c26.4-32.6 66.7-53.5 112-53.5c60.4 0 112.1 37.3 133.5 90c3.3 8.2-.6 17.5-8.8 20.8s-17.5-.6-20.8-8.8C583.2 284.9 543 256 496 256c-38 0-71.7 19-91.9 48l43.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16l0-80zm10.5 182c-3.3-8.2 .6-17.5 8.8-20.8s17.5 .6 20.8 8.8c16.7 41.1 56.9 70 103.9 70c38 0 71.7-19 91.9-48L544 432c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-37.5C581.6 491.1 541.3 512 496 512c-60.4 0-112.1-37.3-133.5-90z'
      
    ]
  };

  

  
  

  var faLightCreditCardCircleQuestion = {
    prefix: 'fak',
    iconName: 'light-credit-card-circle-question',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 115.2c-10.1-5.2-20.8-9.4-32-12.6l0-38.6L32 160l0 64 362.8 0c-12.9 9.1-24.5 19.9-34.6 32L32 256l0 160c0 17.7 14.3 32 32 32l275.2 0c5.9 11.4 12.9 22.2 21.1 32L64 480c-35.3 0-64-28.7-64-64L0 96zm32 0l0 32 512 0 0-32c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l80.7 0c-.5 5.3-.7 10.6-.7 16s.2 10.7 .7 16L240 384c-8.8 0-16-7.2-16-16zm128 0c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm48-38.4c0-23 18.6-41.6 41.6-41.6l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16l0-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4zM480 432c0-8.8 7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightFileInvoiceCircleCheck = {
    prefix: 'fak',
    iconName: 'light-file-invoice-circle-check',
    icon: [
      576,
      512,
      [],
      'e01a',
      
      'M0 64C0 28.7 28.7 0 64 0L220.2 0c12.7 0 24.9 5.1 33.9 14.1L369.9 130c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 128c0-17.7 14.3-32 32-32l192 0c6.6 0 12.7 2 17.8 5.4c-7.9 8.2-15.1 17.1-21.3 26.6L96 272l0 64 162.9 0c-1.9 10.4-2.9 21.1-2.9 32L96 368c-17.7 0-32-14.3-32-32l0-64zM224 32.5L224 144c0 8.8 7.2 16 16 16l111.5 0c-.7-2.8-2.1-5.3-4.2-7.4L231.4 36.7c-2-2.1-4.6-3.5-7.4-4.2zM224 432c0-8.8 7.2-16 16-16l22.6 0c3.2 11.2 7.4 21.9 12.6 32L240 448c-8.8 0-16-7.2-16-16zm64-64c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm44.7-11.3c6.2-6.2 16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightFileInvoiceCircleXmark = {
    prefix: 'fak',
    iconName: 'light-file-invoice-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M0 64C0 28.7 28.7 0 64 0L220.2 0c12.7 0 24.9 5.1 33.9 14.1L369.9 130c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 128c0-17.7 14.3-32 32-32l192 0c6.6 0 12.7 2 17.8 5.4c-7.9 8.2-15.1 17.1-21.3 26.6L96 272l0 64 162.9 0c-1.9 10.4-2.9 21.1-2.9 32L96 368c-17.7 0-32-14.3-32-32l0-64zM224 32.5L224 144c0 8.8 7.2 16 16 16l111.5 0c-.7-2.8-2.1-5.3-4.2-7.4L231.4 36.7c-2-2.1-4.6-3.5-7.4-4.2zM224 432c0-8.8 7.2-16 16-16l22.6 0c3.2 11.2 7.4 21.9 12.6 32L240 448c-8.8 0-16-7.2-16-16zm64-64c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm52.7-59.3c6.2-6.2 16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightFlagCircleXmark = {
    prefix: 'fak',
    iconName: 'light-flag-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e005',
      
      'M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16l0 40L133 30.7c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 132.5c-11.2 3.2-21.9 7.4-32 12.6l0-143.5-8.1 4.1c-55.4 27.7-120.5 27.7-175.8 0c-28.3-14.1-60.7-17.7-91.4-10L32 89l0 270 88.6-22.3c48.5-12.1 99.8-6.5 144.5 15.9c17.3 8.7 36 13.7 54.9 15c0 .1 0 .3 0 .4c0 10.9 1 21.6 2.9 31.9c-24.8-1-49.4-7.3-72.1-18.6c-37.9-18.9-81.4-23.7-122.5-13.4L32 392l0 104c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96 0-33L0 64 0 16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm52.7-59.3c6.2-6.2 16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightFlagSlash = {
    prefix: 'fak',
    iconName: 'light-flag-slash',
    icon: [
      640,
      512,
      [],
      'e019',
      
      'M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c7 5.5 8.1 14.7 2.7 22.5c-5.5 7-15.6 8.1-22.5 2.7L6.1 28.6C-.8 23.1-2 13 3.4 6.1zM96 160.7L128 186l0 173 88.6-22.3c33.9-8.5 69.2-8.3 102.7 .3l76.6 60.5c-16.9-2.9-33.4-8.3-49.1-16.1c-37.9-18.9-81.4-23.7-122.5-13.4L128 392l0 104c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96 0-33 0-206.3zM102.8 3c2.6-1.9 5.8-3 9.2-3c8.8 0 16 7.2 16 16l0 6.9L102.8 3zm57.1 45L229 30.6c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C519.8 28 544 43 544 66l0 279.7c0 1.8-.1 3.5-.4 5.3L512 326l0-258.3-8.1 4.1c-55.4 27.7-120.5 27.7-175.8 0c-28.3-14.1-60.7-17.7-91.4-10L191.6 73.1 159.8 48z'
      
    ]
  };

  

  
  

  var faLightPaperPlaneCircleBolt = {
    prefix: 'fak',
    iconName: 'light-paper-plane-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M.1 290c-.8-12.2 5.4-23.7 16-29.7l448-256c10.7-6.1 23.9-5.5 34 1.4s15.4 19.1 13.5 31.2l.1 0L487.8 192.2c-11.4 .5-22.5 2.1-33.2 4.7L474.1 70.5l-269 289.6 96.6 40.3c7.9 3.2 15.6 6.5 23.4 9.7c3.6 14.5 9 28.4 15.9 41.3l-51.5-21.5-.1 0-52.8 66C228.4 506.1 216.1 512 203 512c-23.7 0-43-19.2-43-43l0-93L19.7 317.6C8.5 312.9 .9 302.2 .1 290zM32 288l141.6 59L450.5 48.8 32 288zM192 389.3l0 79.7c0 6.1 4.9 11 11 11c3.3 0 6.5-1.5 8.6-4.1c15.7-19.6 31.3-39.2 47-58.8L192 389.3zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm44.6 3.8c-1.6-4.9 .1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6s5.4 9.9 2.6 14.9L516.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380 440 380c-5.2 0-9.8-3.3-11.4-8.2z'
      
    ]
  };

  

  
  

  var faLightSuitcaseCircleCheck = {
    prefix: 'fak',
    iconName: 'light-suitcase-circle-check',
    icon: [
      640,
      512,
      [],
      'e023',
      
      'M0 160c0-35.3 28.7-64 64-64l64 0 0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 32.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7l0-32.7c0-17.7-14.3-32-32-32l-32 0 0 83.2c-11.4 5.9-22.2 12.9-32 21L384 128l-16 0-224 0-16 0 0 320 211.2 0c5.9 11.4 12.9 22.2 21.1 32L64 480c-35.3 0-64-28.7-64-64L0 160zm32 0l0 256c0 17.7 14.3 32 32 32l32 0 0-320-32 0c-17.7 0-32 14.3-32 32zM160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm44.7-11.3c6.2-6.2 16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightUserCircleInfo = {
    prefix: 'fak',
    iconName: 'light-user-circle-info',
    icon: [
      640,
      512,
      [],
      'e021',
      
      'M0 482.3C0 498.7 13.3 512 29.7 512l365.1 0c-12.9-9.1-24.5-19.9-34.5-32L32 480c1.3-79.7 66.3-144 146.3-144l91.4 0c18.2 0 35.7 3.3 51.7 9.4c1.4-10.8 3.8-21.4 7-31.5c-18.4-6.4-38.2-9.9-58.8-9.9l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128c0 45.7 24.4 88 64 110.9s88.4 22.9 128 0s64-65.1 64-110.9s-24.4-88-64-110.9s-88.4-22.9-128 0S96 82.3 96 128zm32 0c0-34.3 18.3-66 48-83.1s66.3-17.1 96 0S320 93.7 320 128s-18.3 66-48 83.1s-66.3 17.1-96 0s-48-48.8-48-83.1zM352 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144zm32 0c0-61.9 50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112zm80 0c0 8.8 7.2 16 16 16l0 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c0-16 0-32 0-48c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm8-56c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faLightUserCircleMinus = {
    prefix: 'fak',
    iconName: 'light-user-circle-minus',
    icon: [
      640,
      512,
      [],
      'e020',
      
      'M0 482.3C0 498.7 13.3 512 29.7 512l365.1 0c-12.9-9.1-24.5-19.9-34.5-32L32 480c1.3-79.7 66.3-144 146.3-144l91.4 0c18.2 0 35.7 3.3 51.7 9.4c1.4-10.8 3.8-21.4 7-31.5c-18.4-6.4-38.2-9.9-58.8-9.9l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128c0 45.7 24.4 88 64 110.9s88.4 22.9 128 0s64-65.1 64-110.9s-24.4-88-64-110.9s-88.4-22.9-128 0S96 82.3 96 128zm32 0c0-34.3 18.3-66 48-83.1s66.3-17.1 96 0S320 93.7 320 128s-18.3 66-48 83.1s-66.3 17.1-96 0s-48-48.8-48-83.1zM352 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144zm32 0c0-61.9 50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112zm32 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faLightUserCirclePlus = {
    prefix: 'fak',
    iconName: 'light-user-circle-plus',
    icon: [
      640,
      512,
      [],
      'e01f',
      
      'M0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c20.6 0 40.4 3.5 58.8 9.9c-3.3 10.1-5.6 20.7-7 31.5c-16.1-6.1-33.5-9.4-51.7-9.4l-91.4 0c-80 0-145 64.3-146.3 144l328.3 0c10 12.1 21.6 22.9 34.5 32L29.7 512C13.3 512 0 498.7 0 482.3zM96 128c0-45.7 24.4-88 64-110.9s88.4-22.9 128 0S352 82.3 352 128s-24.4 88-64 110.9s-88.4 22.9-128 0S96 173.7 96 128zm32 0c0 34.3 18.3 66 48 83.1s66.3 17.1 96 0s48-48.8 48-83.1s-18.3-66-48-83.1s-66.3-17.1-96 0S128 93.7 128 128zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faSharpRegularHouseRotate = {
    prefix: 'fak',
    iconName: 'sharp-regular-house-rotate',
    icon: [
      640,
      512,
      [],
      'e00d',
      
      'M8.5 237.7l264-224L288 .5c5.2 4.4 10.3 8.8 15.6 13.2L514.9 193c-6.2-.7-12.5-1-18.9-1c-16.8 0-33.1 2.4-48.5 6.8L288 63.5 112 212.8 112 464l80 0 0-168 0-24 24 0 104 0 0 48-80 0 0 144 96 0 0-22.6c13.1 28.4 33.5 52.8 58.8 70.6L88 512l-24 0 0-24 0-234.5L39.6 274.3 8.5 237.7zM352 224l48 0 0 24 0 12.7c25.5-22.8 59.1-36.7 96-36.7c59.1 0 109.8 35.6 132 86.4l-44 19.2c-14.8-33.9-48.7-57.6-88-57.6c-28.5 0-54 12.3-71.6 32l31.6 0 24 0 0 48-24 0-80 0-24 0 0-24 0-80 0-24zm12 201.6l44-19.2c14.8 33.9 48.7 57.6 88 57.6c28.5 0 54-12.3 71.6-32L536 432l-24 0 0-48 24 0 80 0 24 0 0 24 0 80 0 24-48 0 0-24 0-12.7c-25.5 22.8-59.1 36.7-96 36.7c-59.1 0-109.8-35.6-132-86.4z'
      
    ]
  };

  

  
  

  var faSolidBatteryHalfCircleInfo = {
    prefix: 'fak',
    iconName: 'solid-battery-half-circle-info',
    icon: [
      640,
      512,
      [],
      'e022',
      
      'M0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c12.5 0 23.3 7.1 28.5 17.5C549.4 198.3 523.4 192 496 192c-5.4 0-10.7 .2-16 .7l0-16.7c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l240.7 0c-.5 5.3-.7 10.6-.7 16c0 16.6 2.3 32.7 6.6 48L80 416c-44.2 0-80-35.8-80-80L0 176zm96 16l192 0 0 128L96 320l0-128zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm112 0c0 8.8 7.2 16 16 16c0 16 0 32 0 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm8-72c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faSolidBedCirclePlus = {
    prefix: 'fak',
    iconName: 'solid-bed-circle-plus',
    icon: [
      640,
      512,
      [],
      'e007',
      
      'M0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32l224 0c53 0 96 43 96 96l0 42.8C608.1 221.6 555.5 192 496 192c-97.2 0-176 78.8-176 176c0 16.6 2.3 32.7 6.6 48l-6.6 0L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64zM106.7 168c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSolidCreditCardCircleQuestion = {
    prefix: 'fak',
    iconName: 'solid-credit-card-circle-question',
    icon: [
      640,
      512,
      [],
      'e011',
      
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 32L0 128 0 96zM0 224l394.8 0c-41.1 29-69.3 75.1-74.1 128L240 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l80.7 0c3.3 36.3 17.6 69.4 39.6 96L64 480c-35.3 0-64-28.7-64-64L0 224zM96 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm256 0c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm80-46.4l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6zM472 440c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faSolidCreditCardCircleXmark = {
    prefix: 'fak',
    iconName: 'solid-credit-card-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 32L0 128 0 96zM0 224l394.8 0c-41.1 29-69.3 75.1-74.1 128L240 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l80.7 0c3.3 36.3 17.6 69.4 39.6 96L64 480c-35.3 0-64-28.7-64-64L0 224zM96 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm256 0c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm84.7-59.3c-6.2 6.2-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidFileInvoiceCircleCheck = {
    prefix: 'fak',
    iconName: 'solid-file-invoice-circle-check',
    icon: [
      576,
      512,
      [],
      'e01c',
      
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6c-26.4 7.5-50.2 20.9-70 38.8c-5.8-8.1-15.3-13.4-26-13.4L96 224c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160.7 0c-.5 5.3-.7 10.6-.7 16c0 16.6 2.3 32.7 6.6 48L240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l35.2 0c12.9 25.2 31.7 46.9 54.5 63.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM96 256l192 0 0 10.8c-11.3 16-19.9 33.9-25.4 53.2L96 320l0-64zM256 0L384 128l-128 0L256 0zm32 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidFileInvoiceCircleXmark = {
    prefix: 'fak',
    iconName: 'solid-file-invoice-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e01d',
      
      'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6c-26.4 7.5-50.2 20.9-70 38.8c-5.8-8.1-15.3-13.4-26-13.4L96 224c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160.7 0c-.5 5.3-.7 10.6-.7 16c0 16.6 2.3 32.7 6.6 48L240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l35.2 0c12.9 25.2 31.7 46.9 54.5 63.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM96 256l192 0 0 10.8c-11.3 16-19.9 33.9-25.4 53.2L96 320l0-64zM256 0L384 128l-128 0L256 0zm32 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm84.7-59.3c-6.2 6.2-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidFlagCircleCheck = {
    prefix: 'fak',
    iconName: 'solid-flag-circle-check',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 16 69-17.3c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 132.5c-73.8 20.9-127.9 88.7-128 169.1c-23.8-1.4-47.4-7.6-69.2-18.5c-37.9-18.9-81.4-23.7-122.5-13.4L64 352l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 368 0 64 0 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm76.7-11.3c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidFlagCircleXmark = {
    prefix: 'fak',
    iconName: 'solid-flag-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e006',
      
      'M0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 16 69-17.3c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 132.5c-73.8 20.9-127.9 88.7-128 169.1c-23.8-1.4-47.4-7.6-69.2-18.5c-37.9-18.9-81.4-23.7-122.5-13.4L64 352l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 368 0 64 0 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm84.7-59.3c-6.2 6.2-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSolidFlagClock = {
    prefix: 'fak',
    iconName: 'solid-flag-clock',
    icon: [
      640,
      512,
      [],
      'e003',
      
      'M0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 16 69-17.3c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 132.5c-73.8 20.9-127.9 88.7-128 169.1c-23.8-1.4-47.4-7.6-69.2-18.5c-37.9-18.9-81.4-23.7-122.5-13.4L64 352l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 368 0 64 0 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm128-64l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSolidFlagUser = {
    prefix: 'fak',
    iconName: 'solid-flag-user',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 16 69-17.3c38.1-9.5 78.4-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 104.5c-37.9 18-64 56.5-64 101.2c0 29.7 11.6 56.7 30.4 76.7l-21.9 8.2c-46.2 17.4-97.5 14.7-141.7-7.4c-37.9-18.9-81.4-23.7-122.5-13.4L64 352l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 368 0 64 0 32zM352 477.1c0-51.4 41.7-93.1 93.1-93.1l101.8 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9zM426.7 232c14.3-24.8 40.7-40 69.3-40s55 15.2 69.3 40s14.3 55.2 0 80s-40.7 40-69.3 40s-55-15.2-69.3-40s-14.3-55.2 0-80z'
      
    ]
  };

  

  
  

  var faSolidGlobePointerSlash = {
    prefix: 'fak',
    iconName: 'solid-globe-pointer-slash',
    icon: [
      640,
      512,
      [],
      'e01e',
      
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l95.4 74.8c32.2-34 73.7-59.1 120.4-71.5c-22 29.5-39.8 73.5-50.7 126.1l28.3 22.2c6.1-35.1 15.3-66.1 26.4-91.4c10.5-23.6 22.2-40.7 33.5-51.5C303.4 3.2 312.7 0 320 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7l-171.9 0 40.8 32 135.4 0c2.2 20.4 3.3 41.8 3.3 64c0 14.9-.5 29.4-1.5 43.5L481.4 352l76 0c-6 14.9-13.4 29-22 42.4l95.4 74.7c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM64 256c0-22.1 2.8-43.5 8.1-64l49.7 0 70.3 55.4c0 .5 0 1.1 0 1.6L84.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C64.8 279.2 64 267.7 64 256zm9.3 201.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7l121.4-35.7L307.2 338 267.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm219.4 41.3c1-2.2 1.9-4.6 2.7-7.1l0 .1 38.8-132.3 61.3 48.3c-4.2 14.1-9 27.2-14.2 39c-10.5 23.6-22.2 40.7-33.5 51.5C336.6 508.8 327.3 512 320 512c-7.2 0-16.3-3.1-27.3-13.4zm15-282.7l52.4 41c-3.5-24.7-26.3-43.8-52.4-41zM385.4 8.4c78.3 20.7 142 77.5 171.9 151.6l.1 0-116.7 0c-10-63.9-29.8-117.4-55.3-151.6zm.1 495.2c14.4-19.3 26.9-44.8 37-74.8l45.7 36c-24.7 17.5-52.6 30.8-82.6 38.8zM444.8 192l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64z'
      
    ]
  };

  

  
  

  var faThinFlagCircleCheck = {
    prefix: 'fak',
    iconName: 'thin-flag-circle-check',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M0 8C0 3.6 3.6 0 8 0s8 3.6 8 8l0 52L133 30.5C171.1 21 211.4 25.4 246.5 43c46.3 23.2 100.8 23.2 147.1 0l19.7-9.8c15.9-7.9 34.7 3.7 34.7 21.5l0 143.9c-5.4 1.5-10.8 3.3-16 5.4l0-149.1c0-6-6.3-9.9-11.6-7.2l-19.7 9.8c-50.9 25.4-110.7 25.4-161.5 0c-31.7-15.8-68-19.8-102.4-11.2L16 76.5l0 303 108.4-27.1c44.8-11.2 92.2-6 133.5 14.7c19.8 9.9 41.2 15.5 62.8 16.8c.5 5.4 1.2 10.7 2.2 16c-24.8-1-49.4-7.3-72.1-18.6c-37.9-18.9-81.4-23.7-122.5-13.4L16 396l0 108c0 4.4-3.6 8-8 8s-8-3.6-8-8L0 400l0-16.5L0 64 0 8zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm16 0c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm58.3-13.7c3.1-3.1 8.2-3.1 11.3 0L480 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faThinFlagSlash = {
    prefix: 'fak',
    iconName: 'thin-flag-slash',
    icon: [
      640,
      512,
      [],
      'e018',
      
      'M1.7 3C4.5-.4 9.5-1 13 1.7l623.1 496c4.3 2.8 4.9 7.8 2.2 10.4c-2.8 4.3-7.8 4.9-11.3 2.2L3 14.3C-.4 11.5-1 6.5 1.7 3zM96 170.9l16 12.6 0 196 108.4-27.1c37.5-9.4 76.8-7.3 112.9 5.8l44.4 35.1c-10.6-3-20.9-7-30.9-12c-37.9-18.9-81.4-23.7-122.5-13.4L112 396l0 108c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-104 0-16.5 0-212.6zM169.5 45.5l59.5-15C267.1 21 307.4 25.4 342.5 43c46.3 23.2 100.8 23.2 147.1 0l19.7-9.8c15.9-7.9 34.7 3.7 34.7 21.5l0 286.4-16-12.6 0-273.6c0-6-6.3-9.9-11.6-7.2l-19.7 9.8c-50.9 25.4-110.7 25.4-161.5 0c-31.7-15.8-68-19.8-102.4-11.2L185.5 58.1l-16-12.6z'
      
    ]
  };

  

  
  

  var faThinSquarePlusCircleCheck = {
    prefix: 'fak',
    iconName: 'thin-square-plus-circle-check',
    icon: [
      640,
      512,
      [],
      'e014',
      
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 102.6c-5.4 1.5-10.8 3.3-16 5.4l0-108c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l284.5 0c3.6 5.6 7.6 10.9 11.8 16L64 480c-35.3 0-64-28.7-64-64L0 96zM120 256c0-4.4 3.6-8 8-8l88 0 0-88c0-4.4 3.6-8 8-8s8 3.6 8 8l0 88 88 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-88 0 0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88-88 0c-4.4 0-8-3.6-8-8zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm16 0c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm58.3-13.7c3.1-3.1 8.2-3.1 11.3 0L480 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  



export {

  faLightArrowLeftToArcCircleMinus,
  

  faLightArrowRightToArcCircleBolt,
  

  faLightArrowRightToArcCircleCheck,
  

  faLightArrowRightToArcCircleMinus,
  

  faLightBarsCircleArrowLeft,
  

  faLightCircleCheckCircleArrowRight,
  

  faLightCircleRotate,
  

  faLightCreditCardCircleQuestion,
  

  faLightFileInvoiceCircleCheck,
  

  faLightFileInvoiceCircleXmark,
  

  faLightFlagCircleXmark,
  

  faLightFlagSlash,
  

  faLightPaperPlaneCircleBolt,
  

  faLightSuitcaseCircleCheck,
  

  faLightUserCircleInfo,
  

  faLightUserCircleMinus,
  

  faLightUserCirclePlus,
  

  faSharpRegularHouseRotate,
  

  faSolidBatteryHalfCircleInfo,
  

  faSolidBedCirclePlus,
  

  faSolidCreditCardCircleQuestion,
  

  faSolidCreditCardCircleXmark,
  

  faSolidFileInvoiceCircleCheck,
  

  faSolidFileInvoiceCircleXmark,
  

  faSolidFlagCircleCheck,
  

  faSolidFlagCircleXmark,
  

  faSolidFlagClock,
  

  faSolidFlagUser,
  

  faSolidGlobePointerSlash,
  

  faThinFlagCircleCheck,
  

  faThinFlagSlash,
  

  faThinSquarePlusCircleCheck,
  

};
